import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';

export const theme = {
  colors: {
    inmarketGreen: unifiedPlatformColorPalette.inmarketGreen,
    red: unifiedPlatformColorPalette.lightErrorDark,
    white: unifiedPlatformColorPalette.white,
    black: unifiedPlatformColorPalette.black,
    lightGray: '#CCCCCC',
    gray: '#404040',
    darkGray: '#181818',
    darkBlue: '#0F233D',
    blue: '#274C77',
    lightBlue: '#94A9D8',
  },
  charSpacing: {
    tight: -1.5,
    loose: 3,
    veryLoose: 6,
  },
};
